import axios from "axios";

export const DummyJson = async (
    _,
    finallyCallback = () => {},
    payload = {}
) => {
    axios.post(`https://dummyjson.com/products/add`, payload).then((response) => {
        console.log(response.data)
    }).catch((e) => {
        console.log(e)
    })
        .finally(() => {
            finallyCallback();
        });
};
